<template>
  <Modal
    class="cc-modal"
    width="900"
    footer-hide
    v-model="visibility"
    title="银行卡列表"
  >
    <div class="content" v-if="data">
      <div class="row">
        <div style="margin-left: 20px">
          <Button class="bj-search-btn-F85A36" @click="addBackModalVisibility = true"
            >添加银行卡</Button
          >
        </div>
      </div>
      <Table
        class="bj-fff-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="action" slot-scope="{ row }">
          <div class="table-btn" @click="onCancelItem(row.id)">删除</div>
        </template>
      </Table>
    </div>
    <div class="foot">
      <div class="page-tool">
        <Page
          class="pages-fff"
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
    <addBackModal
      :show.sync="addBackModalVisibility"
      @submit-success="onSuccess"
    ></addBackModal>
  </Modal>
</template>
<script>
import { bankCardList, bankCardDelete } from "api/user.js";

import addBackModal from "components/back/addBackModal.vue";
export default {
  name: "backListModal",
  components: {
    addBackModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      tableLoading: false,
      columns: [
        {
          title: "开户人",
          key: "username",
          align: "center",
        },
        {
          title: "银行名称",
          key: "bankName",
          align: "center",
        },
        {
          title: "账号尾数（后4位）",
          key: "cardNumber",
          align: "center",
        },
        {
          title: "添加日期",
          key: "createdTime",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      templateName: "",
      domainName: "",
      page: 1,
      limit: 10,
      total: 0,
      data: [],
      addBackModalVisibility: false,
      reload: false, // 是否添加过数据
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.req_getList();
        }
      },
    },
  },

  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    // 获取列表
    async req_getList() {
      try {
        let params = {
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await bankCardList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 关闭弹窗
    onCancel() {
      this.visibility = false;
      this.$emit("on-reload", this.reload);
      this.reload = false;
    },
    // 分页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 添加银行卡成功
    async onSuccess(callback) {
      await this.req_getList();
      callback(callback);
      this.reload = true;
    },
    // 删除银行卡
    onCancelItem(id) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除此银行卡吗？</p>",
        onOk: async () => {
          const res = await bankCardDelete(id);
          const { code, result } = res;
          if (code === 200 && result) {
            this.$Message.success("删除成功！");
            this.req_getList();
            this.reload = true;
          }
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .cc-modal {
  .ivu-table-tip td {
    border-bottom: none;
  }
}
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
.row {
  display: flex;
  align-items: center;
  line-height: 60px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.page-tool {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
